export const baseTheme = {
  colors: {
    primary: {
      main: '#3C1053',
      ultraDark: '#461B5E',
      dark: '#3C1053',
      toku: '#51276A',
      light1: '#C59FDF',
      light2: '#E5D5F0',
      light3: '#EBE1F2',
      light4: '#F0ECF3',
      light5: '#F3F1F4',
    },
    gray: {
      main: '#373737',
      dark2: '#545454',
      dark3: '#707070',
      medium1: '#8D8D8D',
      medium2: '#A9A9A9',
      light1: '#C6C6C6',
      light2: '#E2E2E2',
      light3: '#F2F2F2',
      light4: '#FAFAFA',
    },
    error: '#B72E29',
    success: '#408645',
    warning: '#D06B35',
    inProcess: '#FFB038',
    inProcessDark: '#A37500',
    info: '#3070DD',
    background: '#F5F5F5',
  },
  typography: {
    color: '#373737',
    fontFamily: '"Manrope", sans-serif',
    buttonTextColor: '#FFFFFF',
    fontWeight: {
      bold: 700,
      semibold: 600,
      medium: 500,
      regular: 400,
    },
  },
  button: {
    borderRadius: '0.5rem',
  },
  input: {
    borderRadius: '0.375rem',
  },
  spacing: '4px',
  breakpoints: {
    mobile: 0,
    desktop: 769,
  },
  iconSet: 'heroicons',
  parseMarkdown: false,
};
